import Alert from 'common/components/alert/Alert';
import FinalFormField from 'common/components/final-form/FinalFormField';
import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import ActionStatus from 'common/types/ActionStatus';
import AlertType from 'common/types/AlertType';
import ChsProfile from 'domain/types/ChsProfile';
import { isValid, validateAddress } from 'domain/utils';
import { saveProfile } from 'features/profile-settings/ProfileSlice';
import React, { useState } from 'react';
import { Button, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Form } from 'react-final-form';
import AddressForm from '../address/AddressForm';

function ContactInformation() {
  const [showValidations, setShowValidations] = useState(false);
  const [profile, setProfile] = useState<ChsProfile>({} as ChsProfile);
  const [status, setStatus] = useState(ActionStatus.none);

  const data = useTypedSelector((state) => state.profile.data);

  const dispatch = useThunkDispatch();
  const submit = async () => {
    setShowValidations(true);
    if (!isValid(validateAddress(profile.address))) {
      // address is validated within the form
      // so we just need to tell the form to show these validations
      return setShowValidations(true);
    }
    setShowValidations(false);
    try {
      setStatus(ActionStatus.saving);
      await dispatch(
        saveProfile({
          ...data,
          ...profile,
        })
      );
      setStatus(ActionStatus.saved);
    } catch (e) {
      setStatus(ActionStatus.failed);
    }
  };

  return (
    <>
      {status === ActionStatus.saved && (
        <Alert type={AlertType.success}>Information has been saved.</Alert>
      )}
      {status === ActionStatus.failed && (
        <Alert type={AlertType.danger}>Information failed to save.</Alert>
      )}
      <h4 className='mb-3'>Account Details</h4>
      <FormGroup>
        <FormLabel>First Name</FormLabel>
        <FormControl value={data.firstName} disabled />
      </FormGroup>
      <FormGroup>
        <FormLabel>Last Name</FormLabel>
        <FormControl value={data.lastName} disabled />
      </FormGroup>
      <FormGroup>
        <FormLabel>Suffix</FormLabel>
        <FormControl value={data.suffix} disabled />
      </FormGroup>
      <Form
        initialValues={{ dayNum: data.dayNum }}
        onSubmit={(values) => setProfile((prev) => ({ ...prev, ...values }))}
      >
        {({ handleSubmit }) => (
          <form onChange={handleSubmit}>
            <FinalFormField name='dayNum' type='number' label='Phone Number' />
          </form>
        )}
      </Form>
      <h4 className='mt-5'>Profile Address</h4>
      <AddressForm
        data={data.address}
        onChange={(values) => {
          setStatus(ActionStatus.none);
          setProfile((prev) => ({ ...prev, address: values }));
        }}
        validate={showValidations}
      />
      <div className='d-flex'>
        <Button
          variant='primary'
          onClick={submit}
          className='ml-auto'
          disabled={status === ActionStatus.saving}
        >
          Save
        </Button>
      </div>
    </>
  );
}

export default ContactInformation;
